import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import { formatDateG, formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import AdminLeftMenu from "./AdminLeftMenu";
import AdminMailConfirm from "./AdminMailConfirm";
import MemberTypeItemNames from "./MemberTypeItemNames";
import "./Admin.css";
import "../admin.css";
//import usersData from './users.json';

export default function AdminDownloads() {
  const search = useLocation().search;
  const qPage = new URLSearchParams(search).get('page'); // page
  console.log('qPage = ' + qPage);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1);

  const [renderingState, setRenderingState] = useState('Main');

  const [his, setHis] = useState([]);
  const history = useHistory();

  const [mailTos, setMailTos] = useState([]);
  const [dests, setDests] = useState([]);
  const [hisElement, setHisElement] = useState({});

  const [refreshCounter, setRefreshCounter] = useState(0);
  const [checks, setChecks] = useState([]);
  const [selectAll, setSelectAll] = useState(0);

  const today = new Date();
  
  console.log('month of today: ' + today.getMonth());

  today.setMonth(today.getMonth() - 1);


  const getFiscalYear = () => {
    const today = new Date();
    const y = today.getFullYear();
    console.log('getFiscalYear: fullYear: ' + y);
    const month = today.getMonth();
    console.log('getFiscalYear: month of today: ' + month);
    
    return month < 10 ? y-1 : y;
  }
  const [sYearOfFee, setSYearOfFee] = useState(getFiscalYear());

  const [kwSubject, setKwSubject] = useState("");
  const [kwMailBody, setKwMailBody] = useState("");

  let year = new URLSearchParams(search).get('y');
  if (!year) year = "2020";

  const [pageLimit, setPageLimit] = useState("10");

  useEffect(() => {
    console.log('useEffect called...');
    const onLoad = async () => {
      try {
        console.log('onLoad called...');
        const anonymousUser = await Auth.currentCredentials();
        //console.log(anonymousUser);
      } catch (e) {
        onError(e);
      }
    };
    onLoad();
  },[refreshCounter]);

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    sYBegin: today.getFullYear(),
    sMBegin: today.getMonth() + 1,
    sDBegin: today.getDate(),
    sYEnd: "0000",
    sMEnd: "00",
    sDEnd: "00",
    mAffiliationName: "",
    orderBy: "1",
    ascOrDesc: "1",
    updateStatus: "0",
  },
  {
    sYBegin: {n:"", f: (value) => { return '' }},
    sMBegin: {n:"", f: (value) => { return '' }},
    sDBegin: {n:"", f: (value) => { return '' }},
    sYEnd: {n:"", f: (value) => { return '' }},
    sMEnd: {n:"", f: (value) => { return '' }},
    sDEnd: {n:"", f: (value) => { return '' }},
    mAffiliationName: {n:"", f: (value) => { return '' }},
    orderBy: {n:"", f: (value) => {  return '' }},
    ascOrDesc: {n:"", f: (value) => { return '' }},
    updateStatus: {n:"", f: (value) => { return '' }},
  });

  const { userProfile } = useAppContext();

  // mAnnualFees checkbox
  const [mAnnualFees, setMAnnualFees] = useState([0,0]);

  const [isLoading, setIsLoading] = useState(false);

  function handleView(e, i) {
    console.log('i = ' + i);
    console.log(his[i].dests);
    setHisElement(his[i]);
    setDests(his[i].dests);
    let a = []; for(let j=0; j < his[i].dests.length; j++) a.push(j);
    setMailTos(a);
    setRenderingState('ViewMail');
  }

  function handleEdit(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/editMembers/${pk}`);
  }

  function handleMAnnualFeesChange(event) {
    console.log('handleMAnnualFeesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mAnnualFees'.length));
    let chs = JSON.parse(JSON.stringify(mAnnualFees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMAnnualFees(chs);
  }
  const setDefaultDateInterval = () => {
  };

  function handleClear(evenat) {
    console.log('handleClear...');
//    setMStatus([0,0,0,0,0]);
    fields.sYBegin = '0000';
    fields.sMBegin = '00';
    fields.sDBegin = '00';
    fields.sYEnd = '0000';
    fields.sMEnd = '00';
    fields.sDEnd = '00';
    fields.mNumEnd = '';
    fields.mAffiliationName = "";
    setMAnnualFees([0,0]);

    setSYearOfFee(getFiscalYear());
    fields.orderBy = "1";
    fields.ascOrDesc = "1";
    setPageLimit("10");
//    setRefreshCounter(refreshCounter+1);
  }

  const getStatusName = (state) => {
      if (1 == state)
	  return '入金済';
      else
	  return '未入金';
  };

  const getMemberId = (data) => {
//    const d = data.split('#');
//    return d[1];
      return data.memberId;
  };

  const handleItemCheckChanged = (e) => {
    console.log('handleItemCheckChanged...');
    let chs = JSON.parse(JSON.stringify(checks));
    console.log(chs);
    if ('selectAll' === e.target.name) {
      for(let i=0; checks.length > i; i++) {
        chs[i] = e.target.checked ? 1 : 0;
        setChecks(chs);
      }
      setSelectAll(e.target.checked ? 1 : 0);
      return;
    }
    console.log(e.target.value);
    setSelectAll(0);
    chs[e.target.value] = e.target.checked ? 1 : 0;
    setChecks(chs);
  };

  const pageClickAction = (e) => {
    e.preventDefault();
    console.log('pageClick');
    console.log(e.target.href.split('#'));
    setCurrentPage(e.target.href.split('#')[1]);
    return false;
  };

    const getToLength = (to) => {
        console.log(to);
                
	return to ? to.length : 0;
    }

  function backFromMail(event) {
    console.log('handleMail');
    console.log(event.target.id);
    setRenderingState('Main');
  }

  function handleDownload(event) {
    console.log('handleDownloads...');
    event.preventDefault();
    console.log(event.target.id);
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })
    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const downloadFile2 = (url) => {
    const a = document.createElement('a')
    a.href = url;
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = async (e) => {
    console.log(`Downloading now.... /memberSummary?y=${sYearOfFee}`);
    setIsLoading(true);
    e.preventDefault()

    const dlUrl = await API.get("sakurajima", `/memberSummary?y=${sYearOfFee}`); //rgs: registered
    console.log(dlUrl)
    downloadFile2(dlUrl)

//    document.getElementById('s3-download-link').setAttribute('href', ms);
/*
   const xhr = new XMLHttpRequest();
    xhr.open('GET', ms);
    xhr.onload = function() {
      if (xhr.status === 200) {
        console.log('success 200');
        console.log(JSON.parse(xhr.responseText));
      }
    };
    xhr.send();
*/  
//    const s3resp = await axios.get(ms);
//    const s3Body = await s3resp.json();
//    console.log(s3Body);

const tmpms = [
    {
        "memberId": "007366",
        "memType": "6",
        "admissionDate": "2014/10/01",
        "destination": "1",
        "termOfDirective": "",
        "birthDate": "1989/04/13",
        "gender": "1",
        "memPaymentMethod": "1",
        "familyName": "大場",
        "givenName": "友裕",
        "familyNameKana": "オオバ",
        "givenNameKana": "トモヒロ",
        "affiliationName": "パナソニックヘルスケア株式会社",
        "affiliationDepertment": "メディコム事業部  調剤システム部 ",
        "affiliationPosition": "",
        "affiliationPostalCode": "",
        "affiliationAddress": "#",
        "affiliationTel": "",
        "affiliationEmail": "sample@rinspo.jp",
        "homePostalCode": "331-0822",
        "homeAddress": "埼玉県#さいたま市北区奈良町126-47  \nフロレスタⅣ  201号",
        "homeTel": "090-6227-1521",
        "createdAt": 1645933261862,
        "updatedAt": 1645933261862,
        "memPost": [
            0,
            0,
            0,
            0,
            0
        ],
        "unsubscribeDate": "2019/09/30",
        "affiliationOccupation": "",
        "status_0": "0",
        "dateOfPayment_0": "HaveNotMadeAPayment",
        "status_1": "0",
        "dateOfPayment_1": "HaveNotMadeAPayment",
        "status_2": "0",
        "dateOfPayment_2": "HaveNotMadeAPayment",
        "infoUpdateStatus": "更新なし"
    },
    {
        "memberId": "006551",
        "memType": "3",
        "admissionDate": "2012/10/05",
        "destination": "2",
        "termOfDirective": null,
        "birthDate": "1960/05/17",
        "gender": "1",
        "memPaymentMethod": "1",
        "familyName": "古屋",
        "givenName": "貴之",
        "familyNameKana": "コヤ",
        "givenNameKana": "タカユキ",
        "affiliationName": "昭和大学江東豊洲病院",
        "affiliationDepertment": "整形外科 ",
        "affiliationPosition": "講師",
        "affiliationPostalCode": "135-8577",
        "affiliationAddress": "東京都#江東区豊洲5-1-38",
        "affiliationTel": "03-6204-6000",
        "affiliationEmail": "taka-koya@med.showa-u.ac.jp",
        "homePostalCode": "171-0043",
        "homeAddress": "東京都 豊島区要町3-45-9-ファミール千川503",
        "homeTel": "090-6125-8670",
        "createdAt": 1645933078821,
        "updatedAt": 1649605869691,
        "memPost": [
            0,
            0,
            0,
            0,
            0
        ],
        "memCommittee": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ],
        "unsubscribeDate": null,
        "affiliationOccupation": "医師",
        "status_0": "0",
        "dateOfPayment_0": "HaveNotMadeAPayment",
        "status_1": "0",
        "dateOfPayment_1": "HaveNotMadeAPayment",
        "status_2": "1",
        "dateOfPayment_2": "2021/12/10",
        "infoUpdateStatus": "2022/04/10 15:51:09"
    }
]
    setIsLoading(false);
/*
    downloadFile({
      data: [...headers, ...usersCsv].join('\n'),
      fileName: 'users.csv',
      fileType: 'text/csv',
    })
*/
  }


  function renderViewHistory() {
    console.log('renderViewHistory...');
    console.log(dests);
    return (
      <AdminMailConfirm
        his={hisElement}
        members={dests}
        backFromMail={backFromMail}
        mailTos={mailTos}
      />
    );
  }

  function renderMain() {
    return (
              <section id="contents" className="top">
                <h2>ダウンロード</h2>
                <div id="search">
                  <h3>検索条件</h3>
                  <Table>
                    <tbody>
                      <tr>
                        <th>年度</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sYearOfFee" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sYearOfFee"
                              value={sYearOfFee}
                              onChange={ (e) => setSYearOfFee(e.target.value) }
                            >
                              <option value="2012">2012</option>
                              <option value="2013">2013</option>
                              <option value="2014">2014</option>
                              <option value="2015">2015</option>
                              <option value="2016">2016</option>
                              <option value="2017">2017</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                            </Form.Control>
                              &nbsp;年度までの３年間
                          </Form.Group>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
               </div>
	    {/*
                <div id="search">
                  <h3>条件検索</h3>
                  <div className="search_btn">
                    <Button id="searchBtn" active size="sm" active onClick={ handleSearch }>検索</Button>
                    <Button id="resetBtn" active size="sm" active onClick={ handleClear }>検索条件クリア</Button>
                  </div>
                </div>
	     */}
               <div id="list">
                 <LoaderButton
                   block
                   size="lg"
                   variant="success"
                   onClick={ exportToCsv }
                   isLoading={isLoading}
                   id="confirm"
                 >
                   ダウンロードCSV
                 </LoaderButton>
               </div>
	    {/*               <a id="s3-download-link" href="">aaa</a> */}
              </section>
    );
  }

  return (
    <div className="Admin">
      <h1 id="page_title">管理者用　ダウンロード</h1>
      <div className="container">
        <div id="sub_page">
          <div id="admin" className="top">
              <AdminLeftMenu />
	  { renderingState == 'Main' ? renderMain() : renderViewHistory() }
          </div>
        </div>
      </div>
    </div>
  );
}
